import { Button } from "@website/ui-old/button";
import { useActions } from "@website/ui-old/datepicker/components/actions/actions.hook";
import styles from "@website/ui-old/datepicker/components/actions/actions.module.scss";
import { ActionsPropertiesType } from "@website/ui-old/datepicker/components/actions/actions.types";
import { FC, memo } from "react";

const Actions: FC<ActionsPropertiesType> = (properties) => {
  const { calendarLocale = "gregorian" } = properties;

  const { showTodayButtonProperties, changeCalendarLocaleButtonProperties } =
    useActions(properties);

  return (
    <div className={styles["container"]}>
      <Button {...changeCalendarLocaleButtonProperties}>
        تبدیل به {calendarLocale === "persian" ? "میلادی" : "پارسی"}
      </Button>
      <Button {...showTodayButtonProperties}>امروز</Button>
    </div>
  );
};

const ActionsMemoized = memo(Actions);
/**
 * @deprecated please use @website/ui instead
 */
export { ActionsMemoized /**
 * @deprecated please use @website/ui instead
 */ as Actions };
